import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed, withDefaults } from "vue";
import { FlexBoxProps } from "@/types";
import { useMargins } from "@/hooks";


/**
 * A generic component for displaying flex content.
 */
const __default__ = {
  name: "FlexBox",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    align: { default: "start" },
    justify: { default: "start" },
    maxWidth: { default: undefined },
    fullWidth: { type: Boolean },
    column: { type: Boolean },
    wrap: { type: Boolean },
    x: { default: "" },
    y: { default: "" },
    l: { default: "" },
    r: { default: "" },
    t: { default: "" },
    b: { default: "" }
  },
  setup(__props: any) {

const props = __props;

const className = useMargins(props, () => [
  [true, props.column ? "column" : "row"],
  ["align", `align-${props.align}`],
  ["justify", `justify-${props.justify}`],
  ["fullWidth", "full-width"],
  ["wrap", "wrap"],
  [!props.wrap, "nowrap"],
]);

const style = computed(() =>
  props.maxWidth ? `max-width: ${props.maxWidth}px` : ""
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_unref(className)),
    style: _normalizeStyle(style.value)
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 6))
}
}

})